import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PaymentState } from "../model";
import { PaymentStateFeatureKey } from "./payment.reducer";

const paymentFeatureSelector = createFeatureSelector<PaymentState>(PaymentStateFeatureKey);

const getFlightOffer = createSelector(
  paymentFeatureSelector,
  (state: PaymentState) => state?.flightOffer,
);

const getFlightOrder = createSelector(
  paymentFeatureSelector,
  (state: PaymentState) => state?.flightOrder,
);


const getLoading = createSelector(
  paymentFeatureSelector,
  (state: PaymentState) => state?.loading,
);

const getLoaded = createSelector(
  paymentFeatureSelector,
  (state: PaymentState) => state?.loaded,
);

const getErrors = createSelector(
  paymentFeatureSelector,
  (state: PaymentState) => state?.error,
);

export const PaymentSelectors = {
  getFlightOffer,
  getFlightOrder,
  getLoading,
  getLoaded,
  getErrors,
};
